"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M23.685 26.755a.539.539 0 0 0 .633 0L48 9.387V8a2.1 2.1 0 0 0-2.182-2H2.182A2.1 2.1 0 0 0 0 8v1.387zM48 14.162l-13.193 9.675L48 31.092v-16.93z" }),
  React.createElement("path", { d: "M31.419 26.321l-4.562 3.346a5.012 5.012 0 0 1-5.712 0L16.56 26.3 0 35.437V38a2.1 2.1 0 0 0 2.182 2h43.636A2.1 2.1 0 0 0 48 38v-2.561zm-18.247-2.502L0 14.161v16.928l13.172-7.27z" })
);

